import { Component, Input } from "@angular/core";
// @ts-ignore
import _ from "lodash";
import { AuthService } from "src/app/services/auth.service";
import { ProductionTextsService } from "src/app/services/production-texts.service";
import { ProofreadingService } from "src/app/services/proofreading.service";
import { FlowType } from 'src/app/models/proofreading.model';
import { ProjectService } from "src/app/services/project.service";
import { MembersService } from "src/app/services/member.service";
import { USER_TYPE_CPP, USER_TYPE_ADMIN, USER_TYPE_FAB, USER_TYPE_OPERATOR } from "src/app/models/usersTypes.model";
import { StateMachineService } from "src/app/services/machine-state.service";
import { MarqueService } from "src/app/services/marque.service";


@Component({
    selector: "app-split-view-side-head",
    templateUrl: "./split-view-side-head.component.html",
    styleUrls: ["./split-view-side-head.component.scss"],
})
export class SplitViewSideHeadComponent {

    @Input() type: 'intern' | 'extern' | 'revisions' = 'intern';

    get displayedState() {
        if (this.type === 'intern') {
            return this.internState;
        } else {
            return this.externState;
        }
    }

    get externState() {
        return this.s_proofreadings.current?.state;
    }

    get internState() {
        return this.s_proofreadings.current?.intern?.currentState;
    }

    get flow() {
        return this.s_proofreadings.current?.flow;
    }

    get userType() {
        return this.s_auth.getUserType();
    }

    get isClientOnly() {
        return this.s_auth.isClient() && !this.s_auth.hasRole([USER_TYPE_CPP, USER_TYPE_ADMIN, USER_TYPE_FAB, USER_TYPE_OPERATOR]);
    }

    get display() {
        return this.s_productionTexts.display;
    }
    set display(value: 'legal' | 'marketing' | 'tvn') {
        this.s_productionTexts.display = value;
    }

    get has_textes_flow() {
        return this.flow === FlowType.EXE || this.flow === FlowType.EZD_EXE;
    }

    get textes() {
        return this.s_productionTexts.current;
    }

    get id_maitre() {
        return this.s_project.current?.id_maitre;
    }

    get hasDecision() {
        return this.s_members.hasDecision;
    }

    get has_attachements_flow() {
        return this.flow !== FlowType.EZD_EXE && this.flow !== FlowType.EZD_PDF_REPOSITORY && this.flow !== FlowType.BAT;
    }

    get enable_attachments() {
        return this.s_marques.current?.flags?.enable_attachments || false;
    }

    constructor(
        protected s_members: MembersService,
        protected s_project: ProjectService,
        protected s_proofreadings: ProofreadingService,
        protected s_productionTexts: ProductionTextsService,
        protected s_auth: AuthService,
        protected s_sm: StateMachineService,
        protected s_marques: MarqueService
    ) { }

    openPluginParentFolder() {
        if (this.s_project.current) {
            this.s_project.openFolderParent(this.s_project.current);
        }
    }

    isCPP() {
        return this.s_auth.isCPP();
    }

    isClient() {
        return this.s_auth.isClient();
    }

    getSlugText(next: string): string {
        const next_state = this.s_sm.entities.find(e => e.slug === next && e.type === this.type && e.flow.includes(this.s_proofreadings?.current?.flow || FlowType.EXE));
        return next_state?.payload?.text_slug || next;
    }
}
